import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

import { SectionHeader_2 } from '../../../../../component/landingComponent';
const CbHowDoWeDoIt = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`How we do it?`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                We leverage our frameworks, the best practices, and our deep expertise to make AI Agents according to your specifications.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You may also choose your tech stack- open-sourced or licensed. But we will make the best out of it for you.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Manage yourself (or) take AMC from us.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto'>
                    <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 pe-0 w-100" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {CbHowDoWeDoIt}